import axios from 'axios';

export function getFormDetails(formId) {
  return async () => {
    const res = await axios.get('/api/challengeSignUps/getFormDetails', {
      params: { formId },
    });
    return res.data;
  };
}

export function submitChallengeSignUp(req) {
  return async () => {
    const res = await axios.post(
      '/api/challengeSignUps/submitChallengeSignUp',
      req,
    );
    return res.data;
  };
}
